module.exports = __webpack_public_path__ + "static/media/wordmark.e85c9605.svg";